import { connect } from 'react-redux'
import { IStateProps, IDispatchProps } from './YumCustomEntry'
import YumCustomEntry from './YumCustomEntry'
import { IGlobalState } from '../../Root/store/appReducer'
import { CompanyId, GoalWithProgress, Role, DivisionCategoryRow } from '../../services/api.types'
import {
  getAllDailyProgressSelector,
  getCustomProgressRawSelector,
  getCustomProgressSelector,
  getDailyProgressSelector,
  getIsManualEntryInProgress,
  getManualEntryPointsLogicIdSelector,
  getManualEntryProgressTypeSelector,
  getProgressResultsSelector,
} from '../../views/Progress/store/progressSelectors'
import { getUserDto, hasRoleInCompany } from '../../common/auth/authSelectors'
import { getCustomTypeWithLegacy } from '../../services/CustomTypes'
import { getGroupSum } from '../../views/Activity/store/ActivitySelectors'
import { getDivisionCategories } from '../../views/TeamManagement/store/TeamManagementSelectors'
import { getDivisionCategories as getDivisionCategoriesAction } from '../../views/TeamManagement/store/TeamManagementActions'

export interface IOwnProps {
  goal: GoalWithProgress
  showManualEntry?: boolean
  isMeView: boolean
  token?: string
  isLegacyRanking?: boolean
}

const mapStateToProps = (state: IGlobalState, ownProps: IOwnProps): IStateProps => {
  const { goal, showManualEntry, isMeView, token, isLegacyRanking } = ownProps
  const goalId = goal.id
  return {
    goal,
    showManualEntry,
    isMeView,
    token,
    isLegacyRanking,
    dailyDiary: getDailyProgressSelector(state, getCustomTypeWithLegacy(goal.customType, goal.progressType)),
    allDailyDiary: getAllDailyProgressSelector(state),
    customProgress: getCustomProgressSelector(state, goalId),
    allCustomProgress: getCustomProgressRawSelector(state, goalId),
    progressResults: getProgressResultsSelector(state),
    userDto: getUserDto(state),
    manualEntryProgressType: getManualEntryProgressTypeSelector(state),
    manualEntryPointsLogicId: getManualEntryPointsLogicIdSelector(state),
    groupSum: getGroupSum(state, goalId),
    isManualEntryInProgress: getIsManualEntryInProgress(state),
    hasRoleInCompany: (companyId: CompanyId, role: Role) => hasRoleInCompany(state, companyId, role),
    divisionCategories: getDivisionCategories(state),
  }
}

const mapDispatchToProps: IDispatchProps = {
  getDivisionCategories: getDivisionCategoriesAction,
}

export default connect(mapStateToProps, mapDispatchToProps)(YumCustomEntry)
